import React from "react";

import { useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import styles from "./AddEmailRecipientInfo.module.scss";
import messages from "./messages";

const AddEmailRecipientInfo: React.FC = () => {
  const intl = useIntl();

  return (
    <Alert
      className={styles.container}
      message={intl.formatMessage(messages.infoMessage)}
      showIcon
    />
  );
};

export default AddEmailRecipientInfo;
